// Billing toggle — client-side price switching for pricing page
// Design: Two-button toggle (Monthly / Annually) inside white card
function initPricingToggle () {
  const monthlyBtn = document.getElementById('billing-toggle-monthly')
  const annualBtn = document.getElementById('billing-toggle-annual')
  if (!monthlyBtn || !annualBtn) return
  if (monthlyBtn.dataset.toggleInitialized) return
  monthlyBtn.dataset.toggleInitialized = 'true'

  function setAnnual (isAnnual) {
    if (isAnnual) {
      annualBtn.classList.add('bg-[#01d680]', 'text-[#043f42]')
      annualBtn.classList.remove('text-black', 'hover:bg-white/50', 'border', 'border-black')
      monthlyBtn.classList.remove('bg-[#01d680]', 'text-[#043f42]')
      monthlyBtn.classList.add('text-black', 'hover:bg-white/50', 'border', 'border-black')
    } else {
      monthlyBtn.classList.add('bg-[#01d680]', 'text-[#043f42]')
      monthlyBtn.classList.remove('text-black', 'hover:bg-white/50', 'border', 'border-black')
      annualBtn.classList.remove('bg-[#01d680]', 'text-[#043f42]')
      annualBtn.classList.add('text-black', 'hover:bg-white/50', 'border', 'border-black')
    }

    document.querySelectorAll('[data-plan]').forEach(function (el) {
      const planKey = el.dataset.plan
      const monthlyPrice = parseInt(el.dataset.monthlyPrice, 10)
      const annualPrice = parseInt(el.dataset.annualPrice, 10)

      if (planKey === 'monthly' || planKey === 'weekly') {
        // Update price number
        el.textContent = isAnnual ? annualPrice : monthlyPrice
        // Show/hide annual billing label
        const label = document.querySelector(`[data-annual-label="${planKey}"]`)
        if (label) label.classList.toggle('hidden', !isAnnual)
      }
    })

    document.querySelectorAll('[data-plan-matrix]').forEach(function (el) {
      const planKey = el.dataset.planMatrix
      const monthlyPrice = parseInt(el.dataset.monthlyPrice, 10)
      const annualPrice = parseInt(el.dataset.annualPrice, 10)

      if (planKey === 'monthly' || planKey === 'weekly') {
        el.textContent = 'R' + (isAnnual ? annualPrice : monthlyPrice)
        const label = document.querySelector(`[data-annual-label-matrix="${planKey}"]`)
        if (label) label.classList.toggle('hidden', !isAnnual)
      }
    })
  }

  monthlyBtn.addEventListener('click', function () { setAnnual(false) })
  annualBtn.addEventListener('click', function () { setAnnual(true) })
}

function initPricingMatrix () {
  const matrixTabs = document.querySelectorAll('.matrix-tab-btn')
  const matrixPanels = document.querySelectorAll('.matrix-plan-panel')
  if (!matrixTabs.length || !matrixPanels.length) return

  function switchTab (tierKey) {
    matrixTabs.forEach(function (tab) {
      const isSelected = tab.dataset.tierKey === tierKey
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      if (isSelected) {
        tab.classList.add('bg-[#01d680]', 'text-[#043f42]', 'shadow-sm', 'ring-1', 'ring-[#01d680]/50')
        tab.classList.remove('bg-gray-100', 'text-gray-700')
      } else {
        tab.classList.remove('bg-[#01d680]', 'text-[#043f42]', 'shadow-sm', 'ring-1', 'ring-[#01d680]/50')
        tab.classList.add('bg-gray-100', 'text-gray-700')
      }
    })

    matrixPanels.forEach(function (panel) {
      if (panel.dataset.panelKey === tierKey) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }

  matrixTabs.forEach(function (tab) {
    if (tab.dataset.matrixListener) return
    tab.dataset.matrixListener = 'true'
    tab.addEventListener('click', function () {
      switchTab(this.dataset.tierKey)
    })
  })

  // Deep linkage from plan cards above
  document.querySelectorAll('[data-matrix-select]').forEach(function (link) {
    if (link.dataset.matrixListener) return
    link.dataset.matrixListener = 'true'
    link.addEventListener('click', function (e) {
      e.preventDefault()
      const targetTier = this.dataset.matrixSelect
      switchTab(targetTier)
      const matrixEl = document.getElementById('feature-matrix')
      if (matrixEl) {
        matrixEl.scrollIntoView({ behavior: 'smooth' })
      }
    })
  })
}

function initPricing () {
  initPricingToggle()
  initPricingMatrix()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPricing)
} else {
  initPricing()
}
document.addEventListener('turbo:load', initPricing)
